<template>

    <div>
        <!--탑메뉴-->
        <topbar-comp></topbar-comp>
        <left-bar-comp>
            <sports-left-bar-comp></sports-left-bar-comp>
        </left-bar-comp>

        <div class="content_section">
            <div class="content">
                <sub-title>JiliGames</sub-title>
                <div class="main_panel">
                    <div class="casino_panel">
                        <div class="casino_re_panel">
                            <div class="p1">
                                <i class="fa fa-won" style="color: #bc955b"></i> Jili Deposit
                            </div>
                            <div class="p2" style="text-align: center">
                                <span style="width: 100%;height: 28px;line-height: 28px">Convert your cash into Jili chip</span>
                            </div>
                            <div class="p3">
                                <button class="btn-change cbg1" @click="change2jilicash()">Cash > Jili Chip</button>
                            </div>
                        </div>
                        <div class="casino_re_panel">
                            <div class="p1">
                                <i class="fa fa-database" style="color: #bc955b"></i> Jili Chip Withdraw
                            </div>
                            <div class="p2" style="text-align: center">
                                <span style="width: 100%;height: 28px;line-height: 28px">Switch Jili Chip</span>
                            </div>
                            <div class="p3">
                                <button class="btn-change cbg2" @click="change2sportsmoney()">Jili Chip > Cash
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="casino_panel">
                    <button class="jilicompbutton"
                            :class="{'btn-cs-active':search.categroyid==sportsConst.JiliGame.CATEGROY_ELECTRONIC_GAME}"
                            @click="changeCategory(sportsConst.JiliGame.CATEGROY_ELECTRONIC_GAME)">Slot
                    </button>
                    <button class="jilicompbutton"
                            :class="{'btn-cs-active':search.categroyid==sportsConst.JiliGame.CATEGROY_CARD_GAME}"
                            @click="changeCategory(sportsConst.JiliGame.CATEGROY_CARD_GAME)">Poker
                    </button>
                    <button class="jilicompbutton"
                            :class="{'btn-cs-active':search.categroyid==sportsConst.JiliGame.CATEGROY_FISHING_GAME}"
                            @click="changeCategory(sportsConst.JiliGame.CATEGROY_FISHING_GAME)">Fishing
                    </button>
                    <button class="jilicompbutton"
                            :class="{'btn-cs-active':search.categroyid==sportsConst.JiliGame.CATEGROY_BET_EXTENSION}"
                            @click="changeCategory(sportsConst.JiliGame.CATEGROY_BET_EXTENSION)">Casino
                    </button>
                </div>
                <div class="casino_panel">
                    <div class="casino">
                        <div v-for="item in jiligameList" @click="openJiliGame(item.gameid)" class="jili-item" v-if="item.display == sportsConst.YES">
                            <div>
                                <img :src="item.imgurl"
                                     style="vertical-align: middle">
                            </div>
                            <div class="gamename">
                                {{item.enname}}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- right 메뉴 -->
        <right-bar-comp>
            <!--내정보-->
            <user-info-comp slot="userinfo"></user-info-comp>
            <right-buttons-comp slot="btns"></right-buttons-comp>
            <!--배팅카트-->
            <sports-bet-cart-comp slot="betcart"></sports-bet-cart-comp>
            <right-bar-banner-comp slot="banner"></right-bar-banner-comp>
        </right-bar-comp>

        <!--위로가기-->
        <scroll-top-comp></scroll-top-comp>
        <foot-comp></foot-comp>

    </div>


</template>

<script>
    import RightBarComp from "../../components/RightBarComp";
    import LeftBarComp from "../../components/LeftBarComp";
    import LeisureLeftComp from "../../components/leisuregame/LeisureLeftComp";
    import ScrollTopComp from "../../components/ScrollTopComp";
    import SubTitle from "../../components/SubTitle";
    import TopbarComp from "../../components/TopbarComp";
    import FootComp from "../../components/FootComp";
    import RightBarBannerComp from "../../components/RightBarBannerComp";
    import {
        addMemberCasinoCash,
        getAccountBalance, getCasinoMaintaining,
        getGameList,
        getGameUrl, getGameUrl2,
        getLobbyUrl, subjectMemberCasinoCash
    } from "../../network/casinoHonorRequest";
    import SportsLeftBarComp from "../../components/sports/SportsLeftBarComp";
    import sportsConst from "../../common/sportsConst";
    import SportsBetCartComp from "../../components/sports/SportsBetCartComp";
    import {RECEIVE_HIDE_LOADING, RECEIVE_SHOW_LOADING} from "../../store/mutation-types";
    import {postionMixin} from "../../common/mixin";
    import UserInfoComp from "../../components/UserInfoComp";
    import RightButtonsComp from "../../components/RightButtonsComp";
    import {
        addJiliGamesCash, getJiliGameLoginUrl,
        getJiliGamesBalance, getJiliGamesList,
        getJiliGamesMaintaining,
        subjectJiligamesCash
    } from "../../network/jiliGamesRequest";

    export default {
        name: "JiliGames",
        mixins: [postionMixin],
        components: {
            RightButtonsComp,
            UserInfoComp,
            SportsBetCartComp,
            SportsLeftBarComp,
            RightBarBannerComp,
            FootComp, TopbarComp, SubTitle, ScrollTopComp, LeisureLeftComp, LeftBarComp, RightBarComp
        },
        data() {
            return {

                sportsConst,
                casinocash: 0,
                position: "JiliGames",
                searchVal: '',
                jiligameList: [],
                search: {},

            }
        },
        methods: {
            change(type) {
                this.type = type
            },
            searchGames() {
                if (this.searchVal === '') {
                    this.jiligameList.forEach(g => {
                        this.$set(g, 'isshow', true)
                    });
                } else {

                    this.jiligameList.forEach(g => {
                        if (g.enname.indexOf(this.searchVal) !== -1) {
                            this.$set(g, 'isshow', true)
                        } else {
                            this.$set(g, 'isshow', false)
                        }

                    });
                }
            },
            change2jilicash() {
                this.$store.commit(RECEIVE_SHOW_LOADING)
                addJiliGamesCash().then(res => {
                    this.$store.commit(RECEIVE_HIDE_LOADING)
                    if (res.data.success) {
                        this.$swal({
                            //title: '전환성공',
                            title: 'Conversion success',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        this.$store.dispatch('actionUserInfo')
                        setTimeout(() => {
                            this.getJiliGamesBalance();
                        }, 1300)

                    } else {
                        this.$swal({
                            //title: '전환실패, ' + res.data.msg,
                            title: 'Conversion failed, ' + res.data.msg,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                    }
                })
            },
            change2sportsmoney() {
                this.$swal({
                    //title: '보유머니로 전환 하시겠습니까?',
                    title: 'Would you like to convert it to your own money?',
                    type: 'question',
                    confirmButtonText: ' Yes ',
                    cancelButtonText: 'Not'
                }).then((res) => {
                    this.$store.commit(RECEIVE_SHOW_LOADING)
                    if (res.value) {
                        subjectJiligamesCash().then((res) => {
                            this.$store.commit(RECEIVE_HIDE_LOADING)
                            if (res.data.success) {
                                this.$swal({
                                    // title: '전환성공',
                                    title: 'Conversion success',
                                    type: 'success',
                                    showCancelButton: false,
                                    showConfirmButton: true
                                })
                                this.casinocash = 0;
                                this.$store.dispatch('actionUserInfo')
                                setTimeout(() => {
                                    this.getJiliGamesBalance();
                                }, 1300)
                            } else {
                                this.$swal({
                                    // title: '전환실패, ' + res.data.msg,
                                    title: 'Conversion failed, ' + res.data.msg,
                                    type: 'error',
                                    showCancelButton: false,
                                    showConfirmButton: true
                                })
                            }

                        })
                    }
                })

            },
            getJiliGamesBalance() {
                getJiliGamesBalance().then(res => {
                    this.$set(this.$store.state.userInfo, 'jilicash', res.data.data)
                })

            },
            getJiliGamesList() {
                this.$store.commit(RECEIVE_SHOW_LOADING)

                getJiliGamesList(this.search).then(res => {
                    this.$store.commit(RECEIVE_HIDE_LOADING)
                    this.jiligameList = res.data.data
                    this.jiligameList.map(game => {
                        this.$set(game, 'display', sportsConst.YES)
                    })
                })
            },
            openJiliGame(gameid) {
                this.$store.commit(RECEIVE_SHOW_LOADING)
                getJiliGameLoginUrl(gameid).then(res => {
                    if (res.data.success) {
                        let url = res.data.data
                        console.log(res)
                        if (url.indexOf("http") !== -1) {
                            window.open(url, '_blank')
                        } else {
                            this.$swal({
                                title: 'Login Url Error',
                                type: 'error',
                                showCancelButton: false,
                                showConfirmButton: true
                            })
                        }
                    } else {
                        this.$swal({
                            title: res.data.msg,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                    }
                    this.$store.commit(RECEIVE_HIDE_LOADING)

                })
            },

            changeCategory(cate) {
                this.search.categroyid = cate
                this.getJiliGamesList()
            }

        },
        created() {
            if (this.$store.state.isLogin) {
                getJiliGamesMaintaining().then(res => {
                    if (res.data.success) {
                        if (!res.data.data) {
                            this.$swal({
                                //title: '카지노 점검중입니다',
                                title: 'The JiliGame is being inspected.',
                                type: 'error',
                                showCancelButton: false,
                                showConfirmButton: true
                            })
                        } else {
                            this.search.categroyid = sportsConst.JiliGame.CATEGROY_ELECTRONIC_GAME
                            this.getJiliGamesList();
                        }
                    } else {
                        this.$swal({
                            title: res.data.msg,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                    }

                })
            }
        }
    }
</script>

<style scoped>
    @import url("../../assets/css/base.css");
    @import url("../../assets/css/common.css");
    @import url("../../assets/css/style.css");
    @import url("../../assets/css/media.css");
    @import url("../../assets/css/sports.css");

    .casino_panel {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 16px;
    }

    .casino_panel .casino_re_panel {
        width: 49.6%;
        height: 160px;
        box-sizing: border-box;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background-color: var(--noticeBg);
    }

    .casino_panel .casino_re_panel .p1 {
        width: 100%;
        text-align: center;
        padding: 10px 0;
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
    }

    .casino_panel .casino_re_panel .p2 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        align-items: center;
        text-align: center;
        padding: 10px 0;
        color: #fff9ff;
        font-size: 14px;
        font-weight: 600;
    }

    .casino_panel .casino_re_panel .p2 .t1 {
        text-align: center;
        width: 30%;
    }

    .casino_panel .casino_re_panel .p2 .t2 {
        text-align: center;
        width: 40%;
    }

    .t2 input {
        width: 100%;
        text-align: center;
        background-color: #ffffff;
        height: 28px;
        color: #0b1423;
    }

    .casino_panel .casino_re_panel .p2 .t3 {
        text-align: center;
        width: 30%;
    }

    .casino_panel .casino_re_panel .p2 .t3 button {
        height: 28px;
        padding: 0 3px;
        border-radius: 1px;
    }

    .casino_panel .casino_re_panel .p2 .btn-all {
        border: 2px solid var(--btn01Bg);
    }

    .casino_panel .casino_re_panel .p2 .btn-reset {
        background-color: var(--btn01Bg);
        color: #ffffff;
        margin-left: 5px;
    }

    .casino_panel .casino_re_panel .p3 {
        text-align: center;
    }

    .casino_panel .casino_re_panel .btn-change {
        height: 36px;
        padding: 0 16px;
        border-radius: 1px;
        color: #353535;
        font-weight: 600;
    }

    .casino_panel .casino_re_panel .cbg1 {
        background: linear-gradient(180deg, #fffd4f, #fffd70) !important;
    }

    .casino_panel .casino_re_panel .cbg2 {
        background: linear-gradient(180deg, #ac7eff, #c09eff) !important;
    }

    .casino_panel .slot-btns {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .casino_panel .slot-btns img {
        cursor: pointer;
        width: 18%;
        --max-width: 180px;
    }

    .casino_panel .slot-btns img:hover {
        transition: .5s;
        opacity: .5;
    }


    .casino_panel .search {
        width: 100%;
        padding: 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
    }

    .casino_panel .search input {
        color: #0c0e0e;
        background-color: #cfcfd1;
        width: 300px;
        height: 32px;
        text-align: center;
    }


    .btn-cs-active {
        background: linear-gradient(180deg, var(--sportsKindButtonBgActive1), var(--sportsKindButtonBgActive2)) !important;
        color: #fff9ff;
        font-weight: 600;
    }

    .casino_panel .jilicompbutton {
        background-color: var(--sportsKindButtonBg1);
        width: 24.5%;
        height: 42px;
    }

    .casino_panel .casino {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
    }

    .casino_panel .casino .jili-item {
        width: 19.5%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
    }
    .casino_panel .casino  .gamename{
        background-color: grey;
        padding: 10px;
        margin-top: 5px;
        width: 80%;
        text-align: center;
        border-radius: 3px;
    }

    .casino_panel .casino .jili-item img {
        width: 100%;
        --border: 1px solid var(--casinoimgbordercolor);
        border-radius: 3px;
    }

    .casino_panel .casino .jili-item img:hover {
        opacity: 0.7;
        transition: .3s;
    }

    @media screen and (max-width: 1024px) {
        .casino_panel .casino_re_panel {
            width: 100% !important;
            margin-top: 5px !important;
        }

    }

    @media screen and (max-width: 800px) {
        .casino_panel .casino .jili-item{
            width: 49% !important;
        }

    }
</style>